export default __webpack_public_path__ + "static/media/7w.052dc4e0.svg";